import React, { useState, useCallback } from 'react'
import PropTypes from 'prop-types'
import { makeStyles, TextField } from '@material-ui/core'
import SydModal from '../../../../components/commonDesign/SydModal'
import SydModalActions from '../../../../components/commonDesign/SydModal/SydModalActions'
import SydButton from '../../../../components/commonDesign/Button'
import Text from '../../../../components/atoms/Text'

const useStyles = makeStyles((theme) => ({
  description: {
    fontSize: 'var(--font-size-sm)',
    color: 'var(--dai-color-text-low)',
    marginBottom: 'var(--margin-sm)'
  },
  textField: {
    width: '100%',
    marginBottom: 'var(--margin-md)',
    '& .MuiInputBase-root': {
      fontSize: 'var(--font-size-sm)'
    }
  }
}))

function MessageFeedbackModal ({ open, onClose, feedbackType, onSubmit }) {
  const classes = useStyles()
  const [feedbackText, setFeedbackText] = useState('')

  const placeholder = feedbackType === 'thumbs_up'
    ? 'Tell us what you liked...'
    : 'Tell us what you didn\'t like...'

  const handleSubmit = useCallback(() => {
    if (onSubmit) {
      onSubmit(feedbackText.trim())
    }
    setFeedbackText('')
    onClose()
  }, [feedbackText, onSubmit, onClose])

  const handleCancel = useCallback(() => {
    setFeedbackText('')
    onClose()
  }, [onClose])

  const handleKeyDown = useCallback((e) => {
    if (e.key === 'Enter' && (e.metaKey || e.ctrlKey)) {
      e.preventDefault()
      handleSubmit()
    } else if (e.key === 'Escape') {
      e.preventDefault()
      handleCancel()
    }
  }, [handleSubmit, handleCancel])

  React.useEffect(() => {
    if (!open) {
      setFeedbackText('')
    }
  }, [open])

  return (
    <SydModal
      open={open}
      onClose={handleCancel}
      title='Feedback'
      size='small'
      position='middle'
    >
      <Text className={classes.description}>
        Please provide details: (optional)
      </Text>
      <TextField
        className={classes.textField}
        multiline
        minRows={2}
        placeholder={placeholder}
        value={feedbackText}
        onChange={(e) => setFeedbackText(e.target.value)}
        onKeyDown={handleKeyDown}
        autoFocus
        variant='outlined'
      />
      <SydModalActions>
        <SydButton
          onClick={handleCancel}
          variant='outline'
        >
          Cancel
        </SydButton>
        <SydButton
          onClick={handleSubmit}
          variant='primary'
          endIcon={feedbackType === 'thumbs_up' ? 'thumbUp' : 'thumbDown'}
        >
          Send
        </SydButton>
      </SydModalActions>
    </SydModal>
  )
}

MessageFeedbackModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  feedbackType: PropTypes.oneOf(['thumbs_up', 'thumbs_down']).isRequired,
  onSubmit: PropTypes.func.isRequired
}

export default MessageFeedbackModal
